import React from 'react';
import { useTranslations } from 'next-intl';

import LinkTo from '@strongio/pretrained-dashboard/components/LinkTo';

export default function LoginSubtitle() {
  const t = useTranslations('login');

  return /*#__PURE__*/(
    React.createElement("div", { className: "mt-2 text-center text-sm leading-5 text-gray-600 max-w" }, "Or",

    ' ', /*#__PURE__*/
    React.createElement(LinkTo, {
      href: "/register",
      className: "font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150" },

    t('create-a-free-account'))));



}